import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import 'moment/min/locales';
import 'moment/locale/fr';
import Link from "react-router-dom/Link";
import Button from "@material-ui/core/Button/Button";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_institutions_details.json';
import PlaceholderImage from "../../../Schools/assets/img/placeholder-school-thumbnail.jpg";

class InstitutionsDetails extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    getEmbedUrl(url) {
        if (!url) return '';

        try {
            const parsedUrl = new URL(url);

            // Cas YouTube (watch?v=...)
            if (parsedUrl.hostname.includes('youtube.com') && parsedUrl.pathname === '/watch') {
                const videoId = parsedUrl.searchParams.get('v');
                if (videoId) {
                    return `https://www.youtube.com/embed/${videoId}`;
                }
            }

            // Cas YouTube Shorts (/shorts/VIDEO_ID)
            if (parsedUrl.hostname.includes('youtube.com') && parsedUrl.pathname.startsWith('/shorts/')) {
                const videoId = parsedUrl.pathname.split('/')[2]; // après /shorts/
                if (videoId) {
                    return `https://www.youtube.com/embed/${videoId}`;
                }
            }

            // Cas YouTube lien court (youtu.be/VIDEO_ID)
            if (parsedUrl.hostname === 'youtu.be') {
                const videoId = parsedUrl.pathname.slice(1);
                if (videoId) {
                    return `https://www.youtube.com/embed/${videoId}`;
                }
            }

            // Cas Vimeo
            if (parsedUrl.hostname.includes('vimeo.com')) {
                const videoId = parsedUrl.pathname.split('/')[1];
                if (videoId) {
                    return `https://player.vimeo.com/video/${videoId}`;
                }
            }

            // Si déjà en format embed, on retourne tel quel
            return url;
        } catch (e) {
            console.error("URL invalide:", url, e);
            return url;
        }
    }

    render() {
        const {institutions} = this.props;
        const types = institutions.types || [];

        moment.locale('fr');

        let idArticle = 'institutions-' + institutions.id;

        let title = institutions.title;
        if (institutions.title_html !== '' && institutions.title_html !== null) {
            title = ReactHtmlParser(institutions.title_html);
        }

        let thumbnailStyles = {};
        let hasVideo = institutions.video && institutions.video !== '';
        let videoUrl = hasVideo ? this.getEmbedUrl(institutions.video) : '';

        if (hasVideo) {
            // On mettra la vidéo dans le rendu directement
            thumbnailStyles = null;
        } else if (institutions.featured_image && institutions.featured_image.details && institutions.featured_image.details !== '') {
            thumbnailStyles = {
                backgroundImage: 'url("' + institutions.featured_image.details + '")',
            };
        } else {
            thumbnailStyles = {
                backgroundImage: `url(${PlaceholderImage})`,
            };
        }

        /**
         * Nettoie les retours à la ligne inutiles dans du HTML WordPress
         * en supprimant les \n entre les balises, tout en gardant ceux dans le texte.
         */
        function sanitizeNewlines(htmlString) {
            if (!htmlString) return '';

            // 1️⃣ Supprime les sauts de ligne et espaces autour des balises
            // Exemple :
            // "<h3>ADRESSE</h3>\nAvenue..."  => "<h3>ADRESSE</h3>Avenue..."
            let cleaned = htmlString.replace(/>\s*\n\s*/g, '>');

            // 2️⃣ Supprime les \n en début et fin de chaîne
            cleaned = cleaned.trim();

            return cleaned;
        }

        return (
            <article id={idArticle} className="institutions">

                    <div className="row no-gutters">
                        <div className="col col-left col-lg-4 d-print-flex">
                            <div id="aside">
                                <div className="inner">
                                    <Button size="medium" className="btnBack" component={props => <Link to={this.props.translate('routes.institutions')} {...props}/>}>
                                        <KeyboardBackspaceIcon className="btnIcon" />
                                        <Translate id="institutions_details.button_back" />
                                    </Button>
                                    <div className="row no-gutters">
                                        <div className="col col-12 order-lg-1 order-2">
                                            <h1>{ReactHtmlParser(title)}</h1>
                                            <div className="types">
                                                {types.map(type => (
                                                    <div key={type.term_id} className="type-term">
                                                        {type.name}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="contact">
                                    {ReactHtmlParser(sanitizeNewlines(institutions.contact))}
                                </div>
                            </div>
                        </div>
                        <div className="col col-right col-12 col-lg-7 offset-lg-1">
                            <div className="wrapper-top">
                                <div className={`featured-image ${hasVideo ? 'has-video' : 'has-image'}`}>
                                    {hasVideo ? (
                                        <div className="video-wrapper">
                                            <iframe
                                                width="100%"
                                                height="315"
                                                src={videoUrl}
                                                title="Video"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    ) : (
                                        <div className="image" style={thumbnailStyles}></div>
                                    )}
                                </div>
                            </div>
                            <div className="row row-content">
                                <div className="col-12 content-inner">
                                    {ReactHtmlParser(sanitizeNewlines(institutions.content))}
                                </div>
                            </div>
                        </div>
                    </div>


            </article>
        );
    }
}

InstitutionsDetails.propTypes = {
    institutions: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(InstitutionsDetails);



// WEBPACK FOOTER //
// ./src/features/Institutions/components/Details/InstitutionsDetails.js